// Used for caching the list of device types

import $api from '@/services/api';

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
  },
  getters: {
    getLoading: (state) => {
      return state.loading;
    },
    getDeviceTypes: (state) => {
      return state.list;
    },
    getDeviceType: (state) => (typeId) => {
      return state.list.find((deviceType) => deviceType.id === typeId) || null;
    },
  },
  mutations: {
    setDeviceTypeList(state, val) {
      state.list = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    ensure({ state, dispatch }) {
      if (!state.list.length) {
        dispatch('fetch');
      }
    },
    // Load the device details and templates for the device
    async fetch({ state, commit }) {
      if (state.loading) return;
      commit('setLoading', true);

      try {
        const deviceTypes = await $api.get('/v1/common/devicetypes');
        commit('setDeviceTypeList', deviceTypes);
      } catch (err) {
        commit('setDeviceTypeList', []);
      }
      commit('setLoading', false);
    },
  },
};
